import React from "react";
function AboutMe({darkMode}){
    return(
        <div>
            <h2>Bio</h2>
            <p>A second year Computer Science student studying at Vellore Institute of Technology.</p>
            <h2>Skills</h2>
            <ul>
            <li>Languages: C, C#, JavaScript, HTML, CSS</li>
            <br></br>
            <li>Frameworks & Libraries: React, React Router</li>
            <br></br>
            <li>Dev Tools: Git & GitHub, GCC Compiler, Bash Scripting</li>
            <br></br>
            <li>Design: Figma (basic)</li>
            </ul>
        </div>
    )
}
export default AboutMe;